import { UIData } from "./types";

export function selectLoading(state: { UIState: UIData }) {
  return state.UIState.loading;
}

export function selectOpeningAccountsLookup(state: { UIState: UIData }) {
  return state.UIState.openingAccountsLookup;
}

export function refreshHomePageData(state: { UIState: UIData }) {
  return state.UIState.refreshHomePageData;
}
